import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FieldBaseComponent } from '../base-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { Observable, defer, isObservable, of } from 'rxjs';

@Component({
  selector: 'app-lib-ff-radio-list',
  styleUrls: ['radio-list.component.scss'],
  templateUrl: 'radio-list.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlyRadioListComponent extends FieldBaseComponent {
  public readonly options$: Observable<any[]> = defer(() => {
    const options = this.props?.options;
    return isObservable(options) ? options : of(Array.isArray(options) ? options : []);
  });

  public readonly optionsList = toSignal(this.options$, { initialValue: [] as any[] });

  public defaultOptions = {
    props: {
      options: [],
      formCheck: 'custom', // 'custom' | 'stacked' | 'inline'
    },
  };
}
